// import React from 'react';
import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../utils/utils';
import customerVNS from './constants/manageAccountNS';

export default data => {
  const blanks = part => Object.keys(part || {}).filter(key => part[key] === '');
  const blankKeys = [...blanks(data.selfCareAddress), ...blanks(data.selfCareContact)];
  const dataCreate = parseToMutationRequest(data, customerVNS, blankKeys);
  const manageAccount = `manageAccount(input: ${dataCreate})`;

  return gql`
  mutation {
    ${manageAccount} {
      accountId
      orderId
      userId
      password
    }
  }
`;
};
